var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGlyph = function SvgGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0a.5.5 0 0 1 .49.402l.108.539A2.5 2.5 0 0 0 17.56 2.9l.54.109a.5.5 0 0 1 0 .98l-.54.108A2.5 2.5 0 0 0 15.6 6.06l-.109.54a.5.5 0 0 1-.98 0l-.108-.54A2.5 2.5 0 0 0 12.44 4.1l-.54-.109a.5.5 0 0 1 0-.98l.54-.108A2.5 2.5 0 0 0 14.4.94L14.51.4A.5.5 0 0 1 15 0ZM8 3a.5.5 0 0 1 .482.368L8.93 5.01a6.5 6.5 0 0 0 4.56 4.561l1.642.448a.5.5 0 0 1 0 .964l-1.641.448a6.5 6.5 0 0 0-4.561 4.56l-.448 1.642a.5.5 0 0 1-.964 0L7.07 15.99a6.5 6.5 0 0 0-4.56-4.561l-1.642-.448a.5.5 0 0 1 0-.964L2.51 9.57A6.5 6.5 0 0 0 7.07 5.01l.448-1.642A.5.5 0 0 1 8 3Z"
  })));
};
export default SvgGlyph;